import { useState } from "react";
import "./DeleteDigitalTwinModal.css";

import { useAppContext } from "../../../../classes/contexts/AppContext";
import { useNotification } from "../../../../classes/contexts/NotificationContext";
import { SnackbarType } from "../../../../classes/enums/SnackbarTypeEnum";
import Button from "../../../../components/button/Button";
import WarningIcon from "../../../../components/icons/WarningIcon";
import IconButton from "../../../../components/iconButton/IconButton";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { deleteDigitalTwin } from "../../../../services/DigitalTwinService";

const DeleteDigitalTwinModal = ({ digitalTwin, onDigitalTwinDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation();
  const { hidePopup } = useAppContext();
  const { addNotification } = useNotification();

  const handleConfirm = async () => {
    if (isDeleting) return;
    const twinId = digitalTwin?.id || digitalTwin?._id;
    if (!twinId) {
      addNotification(
        SnackbarType.ERROR,
        "Unable to delete digital twin: missing identifier."
      );
      return;
    }

    setIsDeleting(true);
    try {
      await deleteDigitalTwin(twinId);
      if (onDigitalTwinDeleted) onDigitalTwinDeleted(twinId);
      hidePopup();
    } catch (error) {
      addNotification(SnackbarType.ERROR, error.message);
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    if (!isDeleting) hidePopup();
  };

  return (
    <div className="App-module-delete-digital-twin-modal-container">
      <div className="App-module-delete-digital-twin-modal-close">
        <IconButton
          icon={IconsEnum.CLOSE}
          onClick={handleClose}
          noBgColor={true}
          disabled={isDeleting}
          title={t("43")}
        />
      </div>
      <div className="App-module-delete-digital-twin-modal-header">
        <WarningIcon />
        <h2>Delete Digital Twin</h2>
      </div>
      <div className="App-module-delete-digital-twin-modal-body">
        <p className="confirmation-question">
          Are you sure you want to delete Digital Twin{" "}
          <strong>{digitalTwin.name}</strong>?
        </p>
        <p className="warning-message">
          Associated plans and measurements will also be deleted.
        </p>
      </div>
      <div className="App-module-delete-digital-twin-modal-actions">
        <Button
          value={t("4")}
          disabled={isDeleting}
          onClick={handleConfirm}
          className="delete-button"
        />
      </div>
    </div>
  );
};

export default DeleteDigitalTwinModal;
